export const rootPath = '/';
export const homePath = '/home';
export const noAccessPath = '/no-access';
export const onboardingPath = '/onboarding';
export const settingsCodeReviewerPath = '/code-reviewer';
export const settingsCodePlannerPath = '/code-planner';
export const settingsRovoDevCLIPath = '/rovo-dev-cli';
export const boysenberryPath = '/flow';
export const boysenberryDashboardPath = '/flow/dashboard';
export const boysenberryCreateEmbedPath = '/flow/create/embed';
export const boysenberryFlowPath = '/flow/s/:flowId';
export const boysenberryCodePagePath = '/flow/s/:flowId/code';
